module.exports = __webpack_public_path__ + "static/media/skillko-logo.4cca13b1.png";